module.exports = __webpack_public_path__ + "img/image27.c7381c6a.jpeg";